/**
 * @name ScheduleService
 * @description Servicio para la gestión de horario
 * @author Gerado de León
 */

import axios from 'axios';
import { Environment } from '@config';

// URL CheckIn Endpoint
const BASE_URL = `${Environment.getCurrent().endpoints.checkIn}/Horario`;

/**
 * Consulta el horario de un usuario
 * @param {any} request { page, size, filter.id, columns }
 * @return {any} promise
 */
const get = (request) => {
  let URL = `${BASE_URL}/Detalle?IdEmpleado=${request}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta las responsabilidades de un usuario
 * @return {any} promise
 */
const getSupervisor = (request) => {
  let URL = request !== 0 ? `${BASE_URL}/Pendientes?IdEmpleado=${request}` : `${BASE_URL}Horario/Pendientes`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta las responsabilidades de un usuario
 * @return {any} promise
 */
const getStatus = (request) => {
  let URL = `${BASE_URL}/Estatus?IdEmpleado=${request}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Edita un horario
 * @param {any} request { Id, Nombre, Peso, IdEmpleado }
 * @return {any} promise
 */
const put = (request) => {
  let URL = `${BASE_URL}?IdEmpleado=${request.IdEmpleado}&IdHorarioEntrada=${request.IdHorarioEntrada}&IdHorarioSalida=${request.IdHorarioSalida}`;

  return axios.put(URL, request.Horario).then(({ data }) => {
    return data;
  });
};

/**
 * Edita la disponibilidad del horario
 * @param {any} request {  }
 * @return {any} promise
 */
const putAviable = (request) => {
  let URL = `${BASE_URL}/HorarioDisponible`;

  return axios.put(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Edita la disponibilidad del horario
 * @param {any} request { IdEmpleado, IdEstatus. Comentario }
 * @return {any} promise
 */
const putStatus = (request) => {
  let URL = `${BASE_URL}/Autorizar?IdEmpleado=${request.IdEmpleado}&Estatus=${request.IdEstatus}`;

  return axios.put(URL, request.Comentario).then(({ data }) => {
    return data;
  });
};

export const ScheduleService = {
  get,
  getSupervisor,
  getStatus,
  put,
  putAviable,
  putStatus,
};